import React from 'react'

const ReportsCQIIcon = (
  <>
    <path
      d="M2.00016 6.25C2.23016 6.25 2.41683 6.06333 2.41683 5.83333V4.16667C2.41683 3.93667 2.23016 3.75 2.00016 3.75C1.77016 3.75 1.5835 3.93667 1.5835 4.16667V5.83333C1.5835 6.06333 1.77016 6.25 2.00016 6.25Z"
      fill="url(#paint0_linear_2457_7874)"
    />
    <path
      d="M11.1332 7.77715L9.95488 8.95548C9.79238 9.11798 9.79238 9.38215 9.95488 9.54465C10.1174 9.70757 10.3815 9.70757 10.544 9.54465L11.7224 8.36631C11.8849 8.20381 11.8849 7.93965 11.7224 7.77715C11.5599 7.61465 11.2957 7.61465 11.1332 7.77715Z"
      fill="url(#paint1_linear_2457_7874)"
    />
    <path
      d="M15.3333 17.083H13.6667C13.4367 17.083 13.25 17.2697 13.25 17.4997C13.25 17.7297 13.4367 17.9163 13.6667 17.9163H15.3333C15.5633 17.9163 15.75 17.7297 15.75 17.4997C15.75 17.2697 15.5633 17.083 15.3333 17.083Z"
      fill="url(#paint2_linear_2457_7874)"
    />
    <path
      d="M8.13617 11.075C7.85867 11.2562 1.33327 15.515 0.674102 16.1733C-0.0567317 16.9046 -0.0567317 18.0937 0.674102 18.825C1.03952 19.1904 1.51952 19.3729 1.99993 19.3729C2.48035 19.3729 2.96077 19.1904 3.32618 18.825C3.98492 18.1662 8.24409 11.6408 8.42492 11.3633C8.47867 11.2808 8.46742 11.1716 8.39784 11.1021C8.32784 11.0321 8.21867 11.0212 8.13617 11.075Z"
      fill="url(#paint3_linear_2457_7874)"
    />
    <path
      d="M2.00016 0.833008C1.76975 0.833008 1.5835 1.01926 1.5835 1.24967C1.5835 1.48009 1.76975 1.66634 2.00016 1.66634C10.7306 1.66634 17.8335 8.76926 17.8335 17.4997C17.8335 17.7301 18.0197 17.9163 18.2502 17.9163C18.4806 17.9163 18.6668 17.7301 18.6668 17.4997C18.6668 8.30967 11.1902 0.833008 2.00016 0.833008Z"
      fill="url(#paint4_linear_2457_7874)"
    />
    <path
      d="M13.3114 6.24967C13.2068 6.24967 13.1022 6.21051 13.0214 6.13217C10.0518 3.25217 6.13766 1.66634 2.00016 1.66634C1.76975 1.66634 1.5835 1.47967 1.5835 1.24967C1.5835 1.01967 1.76975 0.833008 2.00016 0.833008C6.35558 0.833008 10.4756 2.50217 13.6018 5.53384C13.7668 5.69384 13.771 5.95801 13.6106 6.12301C13.5289 6.20717 13.4202 6.24967 13.3114 6.24967Z"
      fill="url(#paint5_linear_2457_7874)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2457_7874"
        x1="2.00016"
        y1="3.75"
        x2="2.00016"
        y2="6.25"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C2C3CD" />
        <stop offset="1" stopColor="#A2A3B4" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2457_7874"
        x1="10.8386"
        y1="7.65527"
        x2="10.8386"
        y2="9.66686"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C2C3CD" />
        <stop offset="1" stopColor="#A2A3B4" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2457_7874"
        x1="14.5"
        y1="17.083"
        x2="14.5"
        y2="17.9163"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C2C3CD" />
        <stop offset="1" stopColor="#A2A3B4" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2457_7874"
        x1="4.29238"
        y1="11.041"
        x2="4.29238"
        y2="19.3729"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5B5E71" />
        <stop offset="1" stopColor="#393A46" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_2457_7874"
        x1="10.1252"
        y1="0.833008"
        x2="10.1252"
        y2="17.9163"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C2C3CD" />
        <stop offset="1" stopColor="#A2A3B4" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_2457_7874"
        x1="7.65587"
        y1="0.833008"
        x2="7.65587"
        y2="6.24967"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5B5E71" />
        <stop offset="1" stopColor="#393A46" />
      </linearGradient>
    </defs>
  </>
)

export default ReportsCQIIcon
